export default __webpack_public_path__ + "static/apple-icon-152x152-e07f7da8b9dca20ecdda1d0ac6fa5474.png";